// extracted by mini-css-extract-plugin
export default {"flowsheetFooterContainer":"FlowsheetFooter_flowsheetFooterContainer__-PTek","flexEnd":"FlowsheetFooter_flexEnd__gqQul"};